import { useNavigate } from 'react-router-dom';

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#e9ecef] dark:bg-[#2C4358] flex items-center justify-center p-5">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <img 
            src="/assets/ots/Servicio_a_Tiempo_icon_128x128.png" 
            alt="Servicio a Tiempo" 
            className="w-24 h-24 object-contain"
          />
        </div>
        <h1 className="text-3xl font-bold text-[#2C4358] mb-4">
          ¡Ups! Página no encontrada
        </h1>
        <p className="text-lg text-[#85929e] mb-8">
          La página que buscas no existe o ha sido movida.
        </p>
        
        <div className="space-y-4">
          <button
            className="w-full bg-[#22B6B2] text-white py-3 px-6 rounded-full text-lg font-bold hover:bg-[#1a8f8c] transition-colors shadow-lg"
            onClick={() => navigate('/')}
          >
            🏠 Volver al Inicio
          </button>
          
          <button
            className="w-full bg-white text-[#85929e] py-3 px-6 rounded-full text-lg font-bold border border-[#f7ebd6] hover:bg-gray-50 transition-colors shadow-md"
                            onClick={() => navigate('/menu')}
          >
            🍽️ Ver Menú
          </button>
          
          <button
            className="w-full bg-white text-[#85929e] py-3 px-6 rounded-full text-lg font-bold border border-[#f7ebd6] hover:bg-gray-50 transition-colors shadow-md"
                            onClick={() => navigate('/profile')}
          >
            👤 Mi Perfil
          </button>
        </div>
        
        <div className="mt-8 text-sm text-[#85929e]">
          <p>¿Necesitas ayuda? Contacta con soporte</p>
          <p className="text-[#22B6B2] font-semibold">soporte@servicioatiempo.com</p>
        </div>
      </div>
    </div>
  );
} 